<template>
  <table
    v-if="viewPort == 'large'"
    class="sm-table sm-customers-table__desktop"
  >
    <thead class="sm-table__head">
      <tr class="sm-txt-upper">
        <th
          class="sm-table__head-item registered sort" 
          :class="currentSort === 'registered_on' && currentSortDir === 'asc' ? 'active' : ''" 
          @click="sortBy('registered_on')"
        >Registered <include-svg :name="'icon-arrow-b-bold'" /></th>
        <th
          class="sm-table__head-item pmb sort sm-txt-center" 
          :class="currentSort === 'pmb' && currentSortDir === 'asc' ? 'active' : ''" 
          @click="sortBy('pmb')"
        >Mailbox# <include-svg :name="'icon-arrow-b-bold'" /></th>
        <th
          class="sm-table__head-item username sort sm-txt-center" 
          :class="currentSort === 'user_name' && currentSortDir === 'asc' ? 'active' : ''" 
          @click="sortBy('user_name')"
        >Username <include-svg :name="'icon-arrow-b-bold'" /></th>
        <th 
          class="sm-table__head-item name sort"
          :class="currentSort === 'full_name' && currentSortDir === 'asc' ? 'active' : ''"
          @click="sortBy('full_name')"
        >Name <include-svg :name="'icon-arrow-b-bold'" /></th>
        <th
          class="sm-table__head-item registered sort" 
          :class="currentSort === 'company_name' && currentSortDir === 'asc' ? 'active' : ''" 
          @click="sortBy('company_name')"
        >Company <include-svg :name="'icon-arrow-b-bold'" /></th>
        <th
          class="sm-table__head-item plan"
        >Plan</th>
        <th
          class="sm-table__head-item registered sort" 
          :class="currentSort === 'started_at' && currentSortDir === 'asc' ? 'active' : ''" 
          @click="sortBy('started_at')"
        >Started at <include-svg :name="'icon-arrow-b-bold'" /></th>
        <th
          v-if="$route.query.tab != 'inactive'"
          class="sm-table__head-item registered sort" 
          :class="currentSort === 'renew_on' && currentSortDir === 'asc' ? 'active' : ''" 
          @click="sortBy('renew_on')"
        >Renew on <include-svg :name="'icon-arrow-b-bold'" /></th>
        <th
          v-if="$route.query.tab && $route.query.tab != 'active'"
          class="sm-table__head-item registered sort" 
          :class="currentSort === 'ended_at' && currentSortDir === 'asc' ? 'active' : ''" 
          @click="sortBy('ended_at')"
        >Ended at <include-svg :name="'icon-arrow-b-bold'" /></th>
        <th class="sm-table__head-item status sm-txt-right">Status</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <customers-item-lvl3
        v-for="item in list"
        :key="item.id"
        :item="item"
        :viewPort="viewPort"
        @action="data => $emit('action', data)"
      />
    </tbody>
  </table>
  <div 
    v-else 
    class="sm-mobile-table sm-customers-table__mobile"
  >
    <div class="sm-mobile-table">
      <div class="sm-mobile-table-item header">
        <div class="sm-mobile-table-item-row">
          <div class="sm-mobile-table-item-row-th name">Username</div>
          <div class="sm-mobile-table-item-row-th pmb sm-txt-center">Mailbox#</div>
          <div 
            v-if="viewPort == 'medium'"
            class="sm-mobile-table-item-row-th username"
          >Username</div>
          <div 
            v-if="viewPort == 'medium'"
            class="sm-mobile-table-item-row-th plan"
          >Plan</div>
          <div class="sm-mobile-table-item-row-th status sm-txt-right">Status</div>
        </div>
      </div>
      <customers-item-lvl3
        v-for="item in list"
        :key="item.id"
        :item="item"
        :viewPort="viewPort"
        @action="data => $emit('action', data)"
      />
    </div>
  </div>
</template>

<script>
import CustomersItemLvl3 from '@/views/admin/pages/customers/components/TableItemLvl3';
import ViewPort from '@/mixins/ViewPort';

export default {
  name: 'customer-table-lvl3',
  components: {
    'customers-item-lvl3': CustomersItemLvl3,
  },
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      currentSort: 'pmb',
      currentSortDir: 'desc',
      allowedBreakpoints: [
        'small',
        'medium',
        'large',
      ]
    };
  },
  mixins: [ViewPort],
  methods: {
    sortBy(key) {
      if (key === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'desc' ? 'asc' : 'desc';
      } else {
        this.currentSortDir = 'desc';
      }
      this.currentSort = key;

      this.$emit('action', {
        name: 'sort',
        params: {
          attribute_name: this.currentSort,
          direction: this.currentSortDir
        }
      })
    }
  }
}
</script>